import React from 'react';
import { AppBar, Toolbar, Typography, Grid } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';


const Header: React.FC = () => {
  return (
    <AppBar position="static" sx={{ backgroundColor: 'green', padding: '8px', position: 'relative' }}>
      <Toolbar>
        {/* Left side */}
        <Grid sx={{ flexGrow: 1 }}>
          <Typography variant="body2"><WSIcons.RestaurantIcon fontSize='small'/> Pool Bar Outlet</Typography>
          <Typography variant="body2"><WSIcons.JuiceIcon fontSize='small'/> Daily</Typography>
        </Grid>

        {/* Center "eZee Burrp!" */}
        <Grid sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
          <Typography variant="h5">eZee Burrp!</Typography>
        </Grid>

        {/* Right side */}
        <Grid sx={{ marginLeft: 'auto', textAlign: 'right' }}>
          <Typography variant="body1"><WSIcons.Person/> Admin</Typography>
          <Typography variant="body2"><WSIcons.TodayIcon fontSize='small'/> 05-02-2018</Typography>
        </Grid>
      </Toolbar>
    </AppBar>


  );
};

export default Header;
